const QualityFood = [
  {
    id: 1,
    image: './images/fastFood.svg',
    name: 'Фаст-фуд',
    desc: 'Наш ресторан пропонує високоякісні страви, які є свіжими, смачними та приготованими з найкращих інгредієнтів, що гарантує, що наші клієнти завжди залишаються задоволеними.',
  },
  {
    id: 2,
    image: './images/healthyFood.svg',
    name: 'Здорове харчування',
    desc: 'Здорова їжа надзвичайно важлива для нас, саме тому ми пропонуємо нашим клієнтам широкий вибір страв з найсвіжіших та найкорисніших інгредієнтів, які є смачними та ситними.',
  },
  {
    id: 3,
    image: './images/hygienaFood.svg',
    name: 'Гігієна харчування',
    desc: 'У нашому ресторані ми прагнемо до найвищої якості та гігієни продуктів харчування, щоб гарантувати нашим клієнтам безпеку та здоровья під час їжі.',
  },
];

export default QualityFood;
